module.exports = __webpack_public_path__ + "img/9788950960766.c8e5c2a1.jpg";